import type { DelimiterType } from '../common/types'
import type { DateUnit } from './types'

export const DefaultDateDelimiter: DelimiterType = '/'
export const DefaultDatePattern: DateUnit[] = ['d', 'm', 'Y']
